const initProjectsBlock = () => {
    const items = document.querySelectorAll('.block-projects__item');

    const setActivePagination = (id) => {
    
        const activeItem = document.querySelector('.js-pagination-button.active');
        const setActive = document.querySelector(`.js-pagination-button[data-id="${id}"]`);

        activeItem && activeItem.classList.remove('active');
        setActive && setActive.classList.add('active');

    }

    /**
     * Function to add smooth scrolling to elements with the class 'js-pagination-button'.
     * It attaches click event listeners and scrolls smoothly to the target section based
     * on the 'data-id' attribute of the clicked button.
     */
    const addSmoothScroll = () => {
        const buttons = document.querySelectorAll('.js-pagination-button');
        buttons && buttons.forEach((button, index) => {
            button.addEventListener('click', event => {
                const container = document.querySelector(`.block-projects`);

                const scrollTop = container.offsetTop + ((items[index].clientHeight * index) + 52) + (20 * index);
                
                // Smooth scroll to the target element
                window.scrollTo({
                    top: scrollTop,
                    behavior: 'smooth'
                });
            });
        });
    };

    /**
     * Checks the position of each item and applies scaling and blur effects based on their proximity.
     * 
     * This function iterates through all items, compares their positions,
     * and applies a scaling transformation to the previous item based on the distance to the next item.
     * It also adds a blur effect to items that are scaled down.
     */
    const checkAndScaleItems = () => {
        // Get the height of each item for calculations
        const itemHeight = items[0].offsetHeight;

        // Iterate over items to check the position of each
        for (let i = 0; i < items.length - 1; i++) {
            const prevItem = items[i];
            const nextItem = items[i + 1];

            const prevRect = prevItem.getBoundingClientRect();
            const nextRect = nextItem.getBoundingClientRect();

            // Calculate the distance between the bottom of the previous item and the top of the next item
            const distance = nextRect.top - prevRect.bottom;

            // Calculate the scale based on the distance
            let scale = 1;  

            if (Math.round(prevItem.offsetTop + prevItem.clientHeight) >= Math.round(nextItem.offsetTop)) {
                // Scale down previous item if next item is above it and they are close
                scale = Math.max(0.85, 1 + (distance / itemHeight) * 0.25);
                
                // Add the blur class if it starts to scale down
                if (scale < 1) {
                    prevItem.classList.add('blur');
                    setActivePagination(nextItem.dataset.id);
                } else {
                    prevItem.classList.remove('blur'); // Remove blur class if not scaled down
                }
                
            } else {
                prevItem.classList.remove('blur');
                if ( i == 0 ) {
                    setActivePagination(prevItem.dataset.id);
                }
            }

            // Apply the scale
            prevItem.style.transform = `scale(${scale})`;
        }

        // Reset the last item (if needed)
        items[items.length - 1].style.transform = `scale(1)`; // Ensure last item is at full scale
    }
    
    // Run the check on scroll
    window.addEventListener('scroll', checkAndScaleItems);
    
    // Run the check initially on page load
    checkAndScaleItems();

    // Initialize scroll on button click
    addSmoothScroll();
};

document.addEventListener('DOMContentLoaded', initProjectsBlock, false)